import React, { useState } from 'react';
import { Image, Spinner } from 'react-bootstrap';
import {  AxiosInstance } from '../../../utils/RequestMethods';

import * as _ from 'lodash'

import ButtonLoading from '../../ButtonLoading/ButtonLoading';
import config from '../../../constants/config';
import images from '../../../constants/images';
import { PaymentCardT } from '../../../types/Payments';

import { parseFloatTotal } from '../../../utils/utilsT';
import { LineItemTransactionT, TransactionT } from '../../../types/TransactionT';
import WithSkeleton from '../../WithSkeleton';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme, Grid, CardContent, Card, Typography, Box } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => createStyles({
    cardContainer: {
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#eee"
        }
    },
    active: {
        backgroundColor: "#eee",
    }

}))


const imagesCreditCard = {
    "VISA": images.VISA,
    "MASTERCARD": images.MASTERCARD,
    'AMEX': images.AMEX,
    'DISCOVER': images.DISCOVER,
    'DEFAULT': images.DEFAULT
}


export type ICreditCardCheckoutProps = {
    item: PaymentCardT

    isLoading: boolean
    isSkeleton?: boolean
    stripe?: any
    onChangeCard?(card: PaymentCardT): void
    primaryCard?: PaymentCardT
}

const LineItemCard: React.FC<ICreditCardCheckoutProps> = (props) => {

    const [processing, setProcessing] = React.useState(false);
    const [requiresCapture, setRequiresCapture] = React.useState(null);
    const classes = useStyles()


    React.useEffect(() => {
        // console.log("props.lineItems->CreditCardCheckout",props.lineItems)
    }, []);



    /**
     *
     * @returns
     */
    const savePrimaryCard = async (): Promise<string> => {
        let data = {
            id: props.item.id
        }
        return await AxiosInstance.post(`${config.url.cards}/primary-card`, data).then((res) => {
            if (res && res.data) {
                return res.data
            }
        })
    }

    /**
     *
     * @returns
     */
    const renderContentCard = () => {
        return (

            <Grid container spacing={2} onClick={async (e) => {
                e.preventDefault()
                await savePrimaryCard()
                if (props.onChangeCard) {
                    props.onChangeCard(props.item)
                }
            }}>

                <Grid item xs={6} sm={3}>
                    <WithSkeleton loading={props.isLoading} propsSkeleton={{ variant: "rectangular", height: 50, width: 70 }}>

                        <Image style={{ height: 60, width: 90 }} src={imagesCreditCard[_.upperCase(props.item.cardType)] ? imagesCreditCard[_.upperCase(props.item.cardType)] : imagesCreditCard["DEFAULT"]} />
                    </WithSkeleton>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Box display="flex" alignItems="center" height="100%" >
                        <WithSkeleton loading={props.isLoading} propsSkeleton={{ height: 30, width: 200 }} >
                            <Typography variant="h6" style={{}}>**** **** **** {props.item.cardNumberMasked} </Typography>
                        </WithSkeleton>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Box display="flex" alignItems="center" height="100%" >

                        <WithSkeleton loading={props.isLoading} propsSkeleton={{ height: 30, width: 100 }} >
                            <Typography variant="h6" > {props.item.cardName} </Typography>
                        </WithSkeleton>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} >
                    <Box display="flex" alignItems="center" height="100%" >
                        <WithSkeleton loading={props.isLoading} propsSkeleton={{ height: 30, width: 100 }} >
                            <Typography  className="" style={{ textTransform: "uppercase", fontWeight: "bold" }}>{props.item.cardType}</Typography>
                        </WithSkeleton>
                    </Box>
                </Grid>


            </Grid>
        )
    }
    return (
        <Card className={`mt-1 mb-1 ${classes.cardContainer} ${props.primaryCard && props.primaryCard.id == props.item.id ? classes.active : ""}`}>
            <CardContent>

                {renderContentCard()}
            </CardContent>
        </Card>
    );
}

export default LineItemCard
export { LineItemCard }

